import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const CodeBlock = ({ children, language = 'text', title = null }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(children);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <div className="my-6 bg-slate-950 border border-slate-800 rounded-xl overflow-hidden">
      {/* Code block header */}
      <div className="flex items-center justify-between px-4 py-3 bg-slate-900 border-b border-slate-800">
        <div className="flex items-center space-x-3">
          <div className="flex space-x-2">
            <div className="w-3 h-3 bg-red-500 rounded-full"></div>
            <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          </div>
          {title && (
            <span className="text-slate-400 text-sm font-medium">{title}</span>
          )}
          {language && (
            <span className="text-cyan-400 text-xs font-mono bg-slate-800 px-2 py-1 rounded">
              {language}
            </span>
          )}
        </div>
        
        <button
          onClick={handleCopy}
          className="flex items-center space-x-2 text-slate-400 hover:text-white transition-colors duration-200 text-sm"
        >
          {copied ? (
            <>
              <Check className="w-4 h-4 text-green-400" />
              <span className="text-green-400">Copied!</span>
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              <span>Copy</span>
            </>
          )}
        </button>
      </div>
      
      {/* Code content */}
      <div className="relative">
        <pre className="p-4 overflow-x-auto text-sm leading-relaxed">
          <code className="text-slate-300 font-mono">
            {children}
          </code>
        </pre>
      </div>
    </div>
  );
};

export default CodeBlock;